import React from 'react';
import { Profile } from '../../../models/UserStore';
import {
  CurrencyType,
  getCurrencyDetails,
} from '../../../constants/currencies';
import { PngIcon } from '../PngIcon';
import styles from './AssetDisplayBar.module.css';
import { AvatarNode } from '../AvatarNode';
import numbro from 'numbro';

export type CurrencyAmount = {
  type: CurrencyType;
  amount: number;
};

type AssetDisplayBarProps = {
  profile: Profile;
  currencies: CurrencyAmount[];
};

export const AssetDisplayBar = (props: AssetDisplayBarProps) => {
  const { profile, currencies } = props;

  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <AvatarNode
          avatar={{
            ...profile.avatar,
            userId: profile.userId,
            source:
              profile.profilePicture && profile.profilePicture.publicUrls?.small
                ? { uri: profile.profilePicture.publicUrls?.small }
                : '',
          }}
          size={44}
        />
      </div>
      <div className={styles.currencyList}>
        {currencies.map(({ type, amount }) => {
          const details = getCurrencyDetails(type);
          return (
            <div key={type} className={styles.currencyItem}>
              <PngIcon
                name={details.icon}
                alt={`${details.displayName} icon`}
                width={24}
                height={24}
                className={styles.icon}
              />
              <span>{numbro(amount).format({ thousandSeparated: true })}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
